__turbopack_context__.v({
  "copyright": "kkxlOq_copyright",
  "footer": "kkxlOq_footer",
  "footerImprint": "kkxlOq_footerImprint",
  "logo": "kkxlOq_logo",
  "love": "kkxlOq_love",
  "printFooter": "kkxlOq_printFooter",
});
